(function () {
  const UTM_STORAGE_KEY = 'seranova:utm-params';
  const SYNC_STORAGE_KEY = 'seranova:utm-private-attributes-synced';

  function isTrackedParamKey(key) {
    return key.startsWith('utm_') || key.startsWith('tw_');
  }

  function getSessionItem(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setSessionItem(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // Ignore storage failures (for example Safari private browsing).
    }
  }

  function parseStoredUtmParams(value) {
    if (!value) {
      return null;
    }

    try {
      const parsed = JSON.parse(value);

      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
        return null;
      }

      return Object.fromEntries(
        Object.entries(parsed).filter(([key, paramValue]) => isTrackedParamKey(key) && typeof paramValue === 'string'),
      );
    } catch (error) {
      return null;
    }
  }

  function getUtmParamsFromUrl() {
    const searchParams = new URLSearchParams(window.location.search);
    const utmParams = {};

    for (const [key, value] of searchParams.entries()) {
      if (!isTrackedParamKey(key) || value === '') {
        continue;
      }

      utmParams[key] = value;
    }

    return utmParams;
  }

  function getOrStoreUtmParams() {
    const storedUtmParams = parseStoredUtmParams(getSessionItem(UTM_STORAGE_KEY));

    if (storedUtmParams && Object.keys(storedUtmParams).length > 0) {
      return storedUtmParams;
    }

    const urlUtmParams = getUtmParamsFromUrl();

    if (Object.keys(urlUtmParams).length === 0) {
      return null;
    }

    setSessionItem(UTM_STORAGE_KEY, JSON.stringify(urlUtmParams));
    return urlUtmParams;
  }

  function buildCartAttributes(utmParams) {
    const attributes = {};

    for (const [key, value] of Object.entries(utmParams)) {
      attributes[key] = value;
    }

    return attributes;
  }

  async function updateCartAttributes(attributes) {
    const rootPath = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${rootPath}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ attributes }),
    });

    if (!response.ok) {
      throw new Error(`Failed to update cart attributes (${response.status})`);
    }
  }

  function runWhenIdle(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 1500 });
      return;
    }

    window.setTimeout(callback, 200);
  }

  async function syncUtmCartAttributes() {
    const utmParams = getOrStoreUtmParams();

    if (!utmParams) {
      return;
    }

    const cartAttributes = buildCartAttributes(utmParams);
    const serializedAttributes = JSON.stringify(cartAttributes);
    const alreadySyncedAttributes = getSessionItem(SYNC_STORAGE_KEY);

    if (alreadySyncedAttributes === serializedAttributes) {
      return;
    }

    try {
      await updateCartAttributes(cartAttributes);
      setSessionItem(SYNC_STORAGE_KEY, serializedAttributes);
    } catch (error) {
      console.error('Unable to sync UTM cart attributes:', error);
    }
  }

  function init() {
    runWhenIdle(() => {
      syncUtmCartAttributes();
    });
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init, { once: true });
  }
})();
